import React, { useState } from "react";
import { useNavigate } from "react-router-dom";
import "../pages/Login.css";
import { useLanguage } from "../context/LanguageContext";
import { t } from "../i18n";
import { FlagTH, FlagUS } from "../components/FlagIcon";
import API from "../config";

function ForgotPassword() {
  const [email, setEmail] = useState("");
  const [message, setMessage] = useState("");
  const [loading, setLoading] = useState(false);
  const navigate = useNavigate();
  const { lang, toggle } = useLanguage();

  const sendOTP = async () => {
    setLoading(true);
    setMessage("");
    try {
      const res = await fetch(`${API}/api/forgot-password`, {
        method: "POST",
        headers: { "Content-Type": "application/json" },
        body: JSON.stringify({ email })
      });
      const data = await res.json();
      if (!res.ok) { setMessage(data.message); setLoading(false); return; }
      navigate("/verify-otp", { state: { email } });
    } catch (err) {
      setMessage("Cannot connect to server");
    } finally {
      setLoading(false);
    }
  };

  return (
    <div className="login-bg">
      <button
        onClick={toggle}
        style={{ position: "fixed", top: 16, right: 16, background: "none", border: "none", cursor: "pointer", zIndex: 100 }}
        title={lang === "th" ? "Switch to English" : "เปลี่ยนเป็นภาษาไทย"}
      >
        {lang === "th" ? <FlagUS size={28} /> : <FlagTH size={28} />}
      </button>

      <div className="glass-card">
        <h4 className="text-center mb-4">{t(lang, "forgotPwdTitle")}</h4>

        <div className="input-group-glass">
          <label>{t(lang, "emailLabel")}</label>
          <input
            type="email"
            value={email}
            onChange={(e) => setEmail(e.target.value)}
            onKeyDown={(e) => e.key === "Enter" && sendOTP()}
          />
        </div>

        <button className="glass-btn-login" onClick={sendOTP} disabled={loading}>
          {loading ? t(lang, "sendingOtp") : t(lang, "sendOtp")}
        </button>

        {message && <p className="text-danger text-center mt-3">{message}</p>}
      </div>
    </div>
  );
}

export default ForgotPassword;
